import React from "react";
import { Button } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { TooltipIcon } from "../../../../assets/js/image";
import * as _ from "../../../../constants/Constants";
import { ToolTip } from "../../../Common/Tooltip/ToolTip";

const ShippingTitleName = (props) => {
  const history = useHistory();
  const handleAddNewLocations = (event) => {
    event.preventDefault();
    history.push({
      pathname: `/${_.BOARDING}/${_.SHIPPING}/${_.SHIPPING_LOCATION}`,
      param: "add",
      state: null,
    });
  };
  const { addOrEditshippingRolePermission } = props;
  const data = (
    <label className="vobSectionTitle" style={{ fontWeight: 400 }}>
      {props.title}
    </label>
  );
  return (
    <div className="col-md-12 mt-2" style={{ display: "flex" }}>
      <div style={{ width: "78%" }}>
        <ToolTip
          toolTipId="toolTipTimezone"
          customStyles="compDetailsFormLabel"
          label={data}
          toolTipText={props.locToolTipTxt}
        />
        {!props.hideTooltip && <TooltipIcon style="m-bottom-5"></TooltipIcon>}
      </div>
      {props?.showAddBtn && (
        <div style={{ width: "22%" }}>
          <Button
            id="addNewLocationBtn"
            size="md"
            className="button-primary-md"
            style={{ minWidth: 180 }}
            disabled={
              props?.vendorProfileId === null ||
              !addOrEditshippingRolePermission
            }
            onClick={(event) => handleAddNewLocations(event)}
          >
            {_.BUTTON_ADD_NEW_LOCATION}
          </Button>
        </div>
      )}
    </div>
  );
};

export default ShippingTitleName;
